module.exports = __webpack_public_path__ + "img/banner.ac5c36f0.png";